/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ListCountries200AllOf
} from './schema'



/**
 * Get a list of Countries
 * @summary Get Countries
 */
export const listCountries = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ListCountries200AllOf>> => {
    return axios.get(
      `/countries`,options
    );
  }


export const getListCountriesQueryKey = () => [`/countries`];

    
export type ListCountriesQueryResult = NonNullable<Awaited<ReturnType<typeof listCountries>>>
export type ListCountriesQueryError = AxiosError<unknown>

export const useListCountries = <TData = Awaited<ReturnType<typeof listCountries>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCountries>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCountriesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCountries>>> = ({ signal }) => listCountries({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listCountries>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

